import { motion } from 'framer-motion'
import Navbar from './navbar'
import Hamburger from './hamburger'
import { EXTERNAL_LINK } from '../../assets/data/external_link'

/**
 * Main header of the web.
 * It will render either Navbar or Hamburger component depending on the screen size.
 */

const Header = () => {
  const links = [
    { to: '/about', title: 'About' },
    { to: '/superheroes', title: 'Superheroes' },
    { to: '/research', title: 'Research Inventory' },
    { to: '/contact', title: 'Contact' },
  ]
  const buttons = [
    {
      title: 'Support Us',
      link: EXTERNAL_LINK.donate,
      width: '100%',
    },
  ]
  return (
    <motion.header
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: [0.33, 1, 0.68, 1] }}
      style={{
        zIndex: 2000,
        position: 'relative',
        backgroundColor: 'white',
      }}
    >
      <Navbar links={links} buttons={buttons} />
      <Hamburger links={links} buttons={buttons} />
    </motion.header>
  )
}

export default Header
